
const breakpoints = {
    xs: "320px",
    sm: "640px",
    md: "1200px",
    lg: "1024px",
    xl: "1280px",
    xxl: "1536px",
}
  
export const devices = {
    xs: `(max-width: ${breakpoints.xs})`,
    sm: `(max-width: ${breakpoints.sm})`,
    md: `(max-width: ${breakpoints.md})`,
    lg: `(max-width: ${breakpoints.lg})`,
    xl: `(min-width: ${breakpoints.xl})`,
    xxl: `(min-width: ${breakpoints.xxl})`,
}
